/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
import UserEmailWidget from 'components/user/templates/userEmailWidget';
import UsernameWidget from 'components/user/templates/usernameWidget';
import TitleField from './TitleField';
import FormEntitiesArrayTemplate from './FormEntitiesArrayTemplate';
import DatePicker from './DatePicker';
import DatePickerPast from './DatePickerPast';
import AttachmentsField from '../../draft/attachments/field/AttachmentsField';
import UserReferenceWidget from './UserReferenceWidget';
import TextWidget from './TextWidget';
import TextAreaWidget from './TextAreaWidget';
import FieldTemplate from './FieldTemplate';
import DescriptionField from './DescriptionField';
import HiddenWidget from './HiddenWidget';
import ObjectFieldTemplate from './ObjectFieldTemplate';
import SelectWidget from './SelectWidget';
import PaperObjectField from './PaperObjectField';
import AlertField from './AlertField';
import FeesRadio from './FeesRadio';
import FeesSelectionField from './FeesSelectionField';
import AddContactButtonField from './AddContactButtonField';
import UppercaseTextFieldWidget from './UppercaseTextFieldWidget';
import LeadingZeroNumberFieldWidget from './LeadingZeroNumberFieldWidget';
import PublicationNumberWidget from './PublicationNumberWidget';
import CheckboxWidget from './CheckboxWidget';
import RadioWidget from './RadioWidget';
import ChipsField from './ChipsField';
import TypicalTextFieldWidget from './TypicalTextFieldWidget';
import TypicalTextAreaWidget from './TypicalTextAreaWidget';
import BioAttachmentsField from '../../draft/attachments/bioMaterial/BioAttachmentsField';
import InformationField from './InformationField';
import AutoCompleteWidget from './AutoCompleteWidget';
import FormLookupAutocompleteField from './FormLookupAutocompleteField';
import ValidatedTextWidget from './ValidatedTextWidget';
import RequestTypeWidget from './RequestTypeWidget';
import AccentColorPicker from './AccentColorPicker';
import OrganizationNameWidget from './OrganizationNameWidget';
import ActionRadioWidget from './ActionRadioWidget';
import SubtitleField from './SubtitleField';
import ConfirmedCheckboxWidget from './confirmation/ConfirmedCheckboxWidget';
import ConfirmedFeesRadioWidget from './confirmation/ConfirmedFeesRadioWidget';
import AmountInputWidget from './AmountInputWidget';
import FormSectionField from './FormSectionField';
import StaticCardField from './StaticCardField';
import AutoFillWidget from './AutoFillWidget';
import RFTokenField from './RFTokenField';

export const fields = {
  TitleField,
  DescriptionField,
  AttachmentsField,
  BioAttachmentsField,
  PaperObjectField,
  AlertField,
  InformationField,
  FeesSelectionField,
  AddContactButtonWidget: AddContactButtonField,
  chips: ChipsField,
  FormSectionField,
  FormLookupAutocompleteField,
  SubtitleField,
  staticCardField: StaticCardField,
  rfTokenField: RFTokenField,
};

export const widgets = {
  text: TextWidget,
  textarea: TextAreaWidget,
  email: TextWidget,
  select: SelectWidget,
  requestTypeWidget: RequestTypeWidget,
  hidden: HiddenWidget,
  date: DatePicker,
  pastDate: DatePickerPast,
  userReferenceWidget: UserReferenceWidget,
  userEmailWidget: UserEmailWidget,
  usernameWidget: UsernameWidget,
  organizationNameWidget: OrganizationNameWidget,
  feesRadio: FeesRadio,
  confirmedFeesRadioWidget: ConfirmedFeesRadioWidget,
  uppercaseText: UppercaseTextFieldWidget,
  leadingZeroNumber: LeadingZeroNumberFieldWidget,
  typicalText: TypicalTextFieldWidget,
  typicalTextArea: TypicalTextAreaWidget,
  publicationNumberWidget: PublicationNumberWidget,
  checkbox: CheckboxWidget,
  confirmedCheckboxWidget: ConfirmedCheckboxWidget,
  radio: RadioWidget,
  actionRadio: ActionRadioWidget,
  autocomplete: AutoCompleteWidget,
  validatedText: ValidatedTextWidget,
  accentColorPicker: AccentColorPicker,
  amountInputWidget: AmountInputWidget,
  autoFillWidget: AutoFillWidget,
};
export const fieldTemplate = FieldTemplate;
export const objectFieldTemplate = ObjectFieldTemplate;

export const templates = {
  TitleFieldTemplate: TitleField,
  DescriptionFieldTemplate: DescriptionField,
  FieldTemplate,
  ObjectFieldTemplate,
  FormEntitiesArrayTemplate,
};

export const arrayTemplates = {
  formEntitiesArrayTemplate: FormEntitiesArrayTemplate,
};
